// extracted by mini-css-extract-plugin
export default {"search":"index_search_ud4kZ","searchInput":"index_searchInput_p4MjP","searchBtn":"index_searchBtn_rxByG"};